exports = module.exports = require("../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.field-container[data-v-6a2162fb],\n  .fields-container[data-v-6a2162fb]{\n      width: 100%;\n}\n.supplementary-field[data-v-6a2162fb] {\n    margin-top: 0;\n    padding-left: 15%;\n    max-width: 85%;\n    margin-bottom: 0;\n}\n", ""]);

// exports
